export const SET_HISTORY_DATA = "SET_HISTORY_DATA";